@if (activeTab === 'client') {
  <div>
    <form [formGroup]="searchForm">
      <mat-form-field appearance="fill" class="clrsgn-form-field search-mat">
        <mat-label class="clrsgn-label">Email Address</mat-label>
        <input
          matInput
          type="text"
          class="search-input"
          id="emailAddress"
          formControlName="searchEmail"
          (keyup.enter)="search()"
          />
          <button class="btn-primary float-end search-button" type="button" (click)="search()">
            <i class="fa-solid fa-magnifying-glass"></i>
          </button>
        </mat-form-field>
        <button type="button"
          class="btn-primary float-end"
          (click)="openAddUserModal()">
          + Add User
        </button>
        @if (!isSearchResults && searchPerformed) {
          <p>No results to display.</p>
        }
        @if (isSearchResults) {
          <div>
            <h5 class="float-start">Name: {{ this.fullName }}<br>Email: {{ this.emailAddress }}</h5>
            <button class="btn-secondary float-start ms-3"
              (click)="openManageCommissions()"
              >
              Manage Commissions
            </button>
          </div>
        }
        @if (isSearchResults && displayClientAccounts && displayClientAccounts.length === 0) {
          <p class="clear-both">User has no client accounts. Please add them to a client using the button to the right.</p>
        }
        @if (displayClientAccounts && displayClientAccounts.length > 0) {
          <div>
            <button type="button"
              class="btn-secondary float-end"
              (click)="onDeleteAll()">
              Delete All Client Accounts
            </button>
            <table id="systemClientAccountsSectionTable" class="table table-responsive" aria-describedby="Client Accounts">
              <thead>
                <tr>
                  <th scope="col" class="name-table-header"  style="width: 40vw">
                    Client Name
                  </th>
                  <th scope="col" class="name-table-header"  style="width: 50vw">
                    Account Types
                  </th>
                  <th scope="col" class="name-table-header"  style="width: 10vw">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (clientAccount of displayClientAccounts; track clientAccount) {
                  <tr>
                    <td>{{ clientAccount.clientName }}</td>
                    <td>
                      <mat-form-field class="clrsgn-form-field">
                        <mat-select placeholder="Roles" [(value)]="clientAccount.roles" multiple>
                          @for (role of accountRoles; track role) {
                            <mat-option #matOption [value]="role.value" (click)="editClientAccount(matOption.selected, clientAccount, role.value)">{{ role.displayValue }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-secondary d-flex align-items-center gap-1"
                        (click)="onDelete(clientAccount)"
                        >
                        <i class="fas fa-trash-alt action-icon cursor-hand"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </form>
    </div>
  }
